import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { VueMaskDirective } from 'v-mask'
import Axios from 'axios'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import firebaseMessaging from './firebase'
import VueAnalytics from 'vue-analytics'

Vue.prototype.$messaging = firebaseMessaging

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.directive('mask', VueMaskDirective)
Vue.config.productionTip = false

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-188639048-1'
})

Vue.prototype.$http = Axios
Vue.prototype.$http.defaults.baseURL = process.env.VUE_APP_BASE_URL

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common.Authorization = token
}

Vue.prototype.$http.interceptors.response.use(null, error => {
  switch (error.response.status) {
    case 403:
      store.commit('resetState')
      break
  }

  router.push('/')
  return Promise.reject(error)
})

store.dispatch('getVariables')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
